module.exports = __webpack_public_path__ + "95d5a32fd0ff3d105b0077afafd8005b.pdf";